import type { Map as ImmutableMapType } from 'immutable';

import type RootState from 'app-components/utils/redux-store/rootState';

import { SHARES_REDUCER_KEY, type Share, type SharesStore } from './types';

type State = Pick<RootState, typeof SHARES_REDUCER_KEY>;

export const getSharestore = (state: State): SharesStore => state[SHARES_REDUCER_KEY];

// required default selectors
export const getResourcesById = (state: State): ImmutableMapType<string, Share> => getSharestore(state).resourcesById;
export const getLoadPending = (state: State): boolean => getSharestore(state).loadPending;
export const getIsLoading = (state: State): boolean => getSharestore(state).isLoading;
export const getError = (state: State): unknown => getSharestore(state).error;
export const getLastSyncDate = (state: State): string | null | undefined => getSharestore(state).lastSyncDate;

export const getSharesById = (state: State): ImmutableMapType<string, Share> => getSharestore(state).resourcesById;
